import _FormBridgeMaster from './FormBridgeMaster';
import _FormBridgeClient from './FormBridgeClient';

export default {
  FormBridgeMaster: _FormBridgeMaster,
  FormBridgeClient: _FormBridgeClient,
};

export const FormBridgeMaster = _FormBridgeMaster;
export const FormBridgeClient = _FormBridgeClient;
